import { all, call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
// import history from 'services/history';

import {
  checkTokenSuccess,
  checkTokenFailure,
  sendEmailSuccess,
} from './actions';

import api from 'services/api';
export function* checkResetToken({ payload }) {
  try {
    const { token } = payload;

    yield call(api.get, `/resetarsenha/${token}`);
    yield put(checkTokenSuccess(token));
  } catch (error) {
    // toast.error(error.response.data.message)
    yield put(checkTokenFailure(error.response.data.message));
  }
}

export function* resetPassowrd({ payload }) {
  try {
    const { senha, confirma: confirmasenha, token } = payload;
    const data = Object.assign({
      senha,
      confirmasenha,
      token,
    });
    yield call(api.put, `/resetarsenha`, data);

    toast.success('SENHA ALTERADA');
    // history.push('/');
  } catch (error) {
    yield put(checkTokenFailure(error.message));
  }
}

export function* sendEmail({ payload }) {
  const { email } = payload;

  try {
    const data = Object.assign({
      email,
    });
    const response = yield call(api.post, `/resetarsenha`, data);
    yield put(sendEmailSuccess(response.data.message));
  } catch (error) {
    yield put(checkTokenFailure(error.message));
  }
}

export default all([
  takeLatest('@resetpassword/CHECK_TOKEN_REQUEST', checkResetToken),
  takeLatest('@resetpassword/RESETPASSWORD_REQUEST', resetPassowrd),
  takeLatest('@resetpassword/SENDEMAIL_REQUEST', sendEmail),
]);
